import React, { useState } from 'react';
import { clsx } from 'clsx';
import { Popin } from '../../type';
import { onImageError, replaceNToBr } from '../../helper';
import styles from '../../product-timeline.module.scss';
import { TimelineStep } from '../../interfaces/timeline';
import { useAnalyticEvents } from '../../fake';
import { useTranslation } from 'react-i18next';
import PopinView from '../../popin';

const TrackingView: React.FC<{
  productId: string;
  userKind: string;
  directShipping: boolean;
  step: TimelineStep;
}> = ({ productId, userKind, directShipping, step }) => {
  const { sendAnalyticEvent } = useAnalyticEvents('orders_sales_timeline');
  const [popin, updatePopin] = useState<Popin | null>(null);
  const { t } = useTranslation();

  if (step.tracking == null) {
    return <></>;
  }
  const { identifier, status, message, tracking, pickUpLocationDetails } = step;

  const analyticData = { label: userKind, product_id: productId };
  const analyticFn = () => {
    if (directShipping === true) {
      sendAnalyticEvent('timeline_tracking_send_direct', analyticData);
    } else if (identifier === 'buyerDeliveryToHub' || identifier === 'sellerDeliveryToHub') {
      sendAnalyticEvent('timeline_tracking_sendin', analyticData);
    } else if (identifier === 'buyerDelivery' || identifier === 'buyerShipment') {
      sendAnalyticEvent('timeline_tracking_sendout', analyticData);
    }
  };

  if (pickUpLocationDetails && tracking) {
    const { label, number, url } = tracking;
    const { name, address, carrier, openingTimes } = pickUpLocationDetails;
    return (
      <div className={styles.ordersSales__mainRight__steps__step__box__tracking}>
        <div className={styles['ordersSales__mainRight__steps__step__box--text--875']}>
          {`${label} `}
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className={clsx(
              styles['ordersSales__mainRight__steps__step__box--text--link'],
              styles['ordersSales__mainRight__steps__step__box--text--875'],
              styles['ordersSales__mainRight__steps__step__box--text--bold'],
            )}
            onClick={analyticFn}
          >
            {number}
          </a>
        </div>
        <div
          className={styles['ordersSales__mainRight__steps__step__box--text--875']}
          dangerouslySetInnerHTML={{ __html: replaceNToBr(message) }}
        />
        <div className={styles.ordersSales__mainRight__steps__step__box__tracking__box}>
          {carrier && carrier.name && carrier.iconUrl && (
            <img
              className={styles.ordersSales__mainRight__steps__step__box__tracking__box__img}
              src={carrier.iconUrl}
              alt={carrier.name}
              onError={onImageError}
            />
          )}
          {carrier && carrier.name && (
            <div
              className={clsx(
                styles['ordersSales__mainRight__steps__step__box--text--875'],
                styles['ordersSales__mainRight__steps__step__box--text--bold'],
              )}
            >
              {carrier.name}
            </div>
          )}
          <div className={styles['ordersSales__mainRight__steps__step__box--text--875']}>{name}</div>
          <div className={styles['ordersSales__mainRight__steps__step__box--text--875']}>{address}</div>
          <button
            className={clsx(
              styles['ordersSales__mainRight__steps__step__box--text--link'],
              styles['ordersSales__mainRight__steps__step__box--text--875'],
            )}
            onClick={() => {
              if (openingTimes) {
                updatePopin({
                  kind: 'PickupOpeningTimes',
                  openingTimes,
                });
                sendAnalyticEvent('timeline_pickup_hours', analyticData);
              }
            }}
          >
            {t('MY_ACCOUNT.ORDERS_SALES.DELIVERY.SHOW_OPENING_TIME')}
          </button>
        </div>
        <PopinView
          popin={popin}
          closePopin={() => updatePopin(null)}
        />
      </div>
    );
  } else if (tracking) {
    const { carrierLabel, carrierName, label, number, url, logoUrl } = tracking;
    if (status === 'done' && label && url) {
      return (
        <div
          className={clsx(
            styles['ordersSales__mainRight__steps__step__box--text--grey'],
            styles['ordersSales__mainRight__steps__step__box--text--875'],
          )}
        >
          {`${label} `}
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className={clsx(
              styles['ordersSales__mainRight__steps__step__box--text--link'],
              styles['ordersSales__mainRight__steps__step__box--text--875'],
              styles['ordersSales__mainRight__steps__step__box--text--bold'],
            )}
            onClick={analyticFn}
          >
            {number}
          </a>
        </div>
      );
    } else if (url && number) {
      return (
        <div
          className={clsx(
            styles.ordersSales__mainRight__steps__step__box__tracking,
            styles['ordersSales__mainRight__steps__step__box__tracking--horizontal'],
          )}
        >
          <div className={styles['ordersSales__mainRight__steps__step__box--text--875']}>
            {carrierName && carrierLabel && (
              <>
                {carrierLabel} {carrierName}
              </>
            )}
            <br />
            {`${label} `}
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              className={clsx(
                styles['ordersSales__mainRight__steps__step__box--text--link'],
                styles['ordersSales__mainRight__steps__step__box--text--875'],
                styles['ordersSales__mainRight__steps__step__box--text--bold'],
              )}
              onClick={analyticFn}
            >
              {number}
            </a>
          </div>
          {logoUrl && (
            <img
              className={styles.ordersSales__mainRight__steps__step__box__tracking__box__img}
              src={logoUrl}
              alt={carrierName}
              onError={onImageError}
            />
          )}
        </div>
      );
    }
  }

  return <></>;
};

export default TrackingView;
